import { PaginationQueryParams } from '../../../../../constants/apiRoutes/paginationQueryParams.ts';
import { Flex, Text } from '@chakra-ui/react';
import { GenericInfiniteList } from './InfiniteList/GenericInfiniteList.tsx';
import { ApiRoute } from '../../../../../constants/apiRoutes/apiRoute.ts';
import { ReactElement, useMemo } from 'react';

interface AuctionInfiniteListProps<T, TParams extends PaginationQueryParams> {
  title: string;
  emptyListMessage?: string;
  route: ApiRoute<TParams>;
  queryParameters?: Partial<TParams>;
  renderItem: (item: T) => ReactElement;
  filterComponent?: ReactElement;
  printComponent?: ReactElement;
}

export const AuctionInfiniteList = <TParams extends PaginationQueryParams>(
  props: AuctionInfiniteListProps<any, TParams>
) => {
  const { title, route, queryParameters, emptyListMessage, renderItem, filterComponent } = props;

  const memoizedQueryParameters = useMemo(
    () => ({
      page: 0,
      pageSize: 10,
      ...queryParameters
    }),
    [queryParameters]
  );

  return (
    <Flex gap={'16px'} direction={'column'}>
      <Flex justifyContent='space-between' alignItems='center'>
        <Flex alignItems='center' gap='4'>
          <Text fontSize='2xl' fontWeight='semibold'>
            {title}
          </Text>
        </Flex>
        <Flex gap='4' alignItems='center'>
          {filterComponent && filterComponent}
          {props.printComponent && props.printComponent}
        </Flex>
      </Flex>
      <GenericInfiniteList
        route={route}
        queryParameters={memoizedQueryParameters}
        renderItem={renderItem}
        emptyListMessage={emptyListMessage}
      />
    </Flex>
  );
};
